import { Avatar, Box, HStack, Text } from '@chakra-ui/react';
import { Tooltip } from '@components/ui/tooltip';
import { useUserProfileContext } from '@contexts/userProfile';

const UserProfile = () => {
  const { profile } = useUserProfileContext();

  if (!profile) return null;

  const emailCut = profile.email.length > 20
    ? `${profile.email.slice(0, 20)}...`
    : profile.email;

  return (
    <HStack gap="3" justify="space-between">
      <HStack gap="3">
        <Avatar.Root>
          <Avatar.Fallback />
          {profile.thumbnail_url && (
            <Avatar.Image src={profile.thumbnail_url} />
          )}
        </Avatar.Root>
        <Box>
          <Text textStyle="sm" fontWeight="medium">
            {profile.name}
          </Text>
          <Tooltip
            content={profile.email}
            showArrow
          >
            <Text textStyle="sm" color="fg.muted">
              {emailCut}
            </Text>
          </Tooltip>
        </Box>
      </HStack>
    </HStack>
  );
};

export default UserProfile;
